/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import "@styles/global.css";
import "./src/styles/antd.less";

// Add ResizeObserver polyfill for Ant Design
export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    // Fix for ResizeObserver not being available in some browsers
    if (!window.ResizeObserver) {
      window.ResizeObserver = class MockResizeObserver {
        constructor(callback) {
          this.callback = callback;
          this.observables = [];
        }
        observe(element) {
          this.observables.push(element);
        }
        unobserve(element) {
          this.observables = this.observables.filter((el) => el !== element);
        }
        disconnect() {
          this.observables = [];
        }
      };
    }
  }
};
